import React from 'react';
import { Link } from 'react-router-dom';

interface Testimonial {
  name: string;
  profession: string;
  image: string;
  rating: number;
  content: string;
}

const TestimonialSection: React.FC = () => {
  const testimonials: Testimonial[] = [
    {
      name: "Aarav Sharma",
      profession: "JEE Advanced Rank 142",
      image: "img/testimonial-1.jpg",
      rating: 5,
      content: "WiziAI's personalized practice tests identified my weak areas in Physics and helped me improve my score by 180 marks! The AI tutor explained complex concepts so clearly. Couldn't have cracked JEE without it!"
    },
    {
      name: "Priya Patel",
      profession: "NEET AIR 95",
      image: "img/testimonial-2.jpg",
      rating: 5,
      content: "The voice-enabled doubt solver was a game-changer! I could ask questions anytime during study sessions. WiziAI's smart analysis helped me focus on high-yield topics and boosted my confidence for NEET."
    },
    {
      name: "Rohit Kumar",
      profession: "IIT Delhi CSE",
      image: "img/testimonial-3.jpg",
      rating: 5,
      content: "WiziBoard's performance tracking kept me motivated throughout my preparation. The leaderboard feature made studying competitive and fun. Thanks to WiziAI's AI-powered insights, I achieved my dream rank!"
    },
    {
      name: "Sneha Gupta",
      profession: "AIIMS Delhi",
      image: "img/testimonial-1.jpg",
      rating: 5,
      content: "WiziAI's adaptive learning system adjusted to my pace perfectly. The instant feedback on mock tests and detailed explanations helped me understand my mistakes and improve continuously. Highly recommend!"
    },
    {
      name: "Karan Verma",
      profession: "IIT Bombay Mechanical",
      image: "img/testimonial-2.jpg",
      rating: 5,
      content: "The AI-powered gap analysis was incredible! It pinpointed exactly which Chemistry topics I needed to work on. WiziTalk made complex organic reactions so much easier to understand. Amazing platform!"
    }
  ];

  const renderStars = (rating: number) => {
    const stars = [];
    for (let i = 1; i <= 5; i++) {
      stars.push(
        <i
          key={i}
          className={`fas fa-star ${i <= rating ? 'text-primary' : 'text-body'}`}
        ></i>
      );
    }
    return stars;
  };

  return (
    <div className="container-fluid testimonial py-5" style={{ 
      background: 'linear-gradient(135deg, #f8f9ff 0%, #e8f0fe 100%)'
    }}>
      <div className="container py-5">
        <div className="row g-5">
          <div className="col-lg-6 col-xl-5 wow fadeInUp" data-wow-delay="0.2s">
            <h4 className="text-primary mb-3">
              <i className="fas fa-star me-2"></i>
              Student Success Stories
            </h4>
            <h1 className="display-4 mb-4" style={{ 
              background: 'linear-gradient(135deg, #667eea, #764ba2)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text'
            }}>
              From Dreams to <span className="fw-bold">Reality</span>
            </h1>
            <p className="mb-4 fs-5 text-muted">
              Discover how thousands of JEE and NEET aspirants transformed their preparation journey 
              with WiziAI's intelligent learning platform and achieved their medical and engineering dreams.
            </p>
            <div className="row g-3 mb-4">
              <div className="col-6">
                <div className="d-flex align-items-center">
                  <div className="d-inline-flex align-items-center justify-content-center rounded-circle me-3"
                    style={{ 
                      width: '50px', 
                      height: '50px',
                      backgroundColor: '#667eea15',
                      border: '2px solid #667eea'
                    }}>
                    <i className="fas fa-trophy text-primary fa-lg"></i>
                  </div>
                  <div>
                    <h5 className="mb-0 fw-bold">98%</h5>
                    <small className="text-muted">Success Rate</small>
                  </div>
                </div>
              </div>
              <div className="col-6">
                <div className="d-flex align-items-center">
                  <div className="d-inline-flex align-items-center justify-content-center rounded-circle me-3"
                    style={{ 
                      width: '50px', 
                      height: '50px',
                      backgroundColor: '#764ba215',
                      border: '2px solid #764ba2'
                    }}>
                    <i className="fas fa-graduation-cap text-primary fa-lg"></i>
                  </div>
                  <div>
                    <h5 className="mb-0 fw-bold">15,000+</h5>
                    <small className="text-muted">Dreams Achieved</small>
                  </div>
                </div>
              </div>
            </div>
            <Link 
              className="btn btn-lg px-5 py-3"
              to="/success-stories"
              style={{
                background: 'linear-gradient(135deg, #667eea, #764ba2)',
                border: 'none',
                borderRadius: '50px',
                color: 'white',
                transition: 'all 0.3s ease'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-3px)';
                e.currentTarget.style.boxShadow = '0 10px 25px rgba(102, 126, 234, 0.3)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = 'none';
              }}>
              <i className="fas fa-users me-2"></i>
              View All Success Stories
            </Link>
          </div>
          <div className="col-lg-6 col-xl-7 wow fadeInUp" data-wow-delay="0.4s">
            <div className="owl-carousel testimonial-carousel">
              {testimonials.map((testimonial, index) => (
                <div key={index} className="testimonial-item">
                  <div className="card border-0 shadow-sm h-100" style={{ borderRadius: '20px' }}>
                    <div className="card-body p-4">
                      <div className="d-flex align-items-start mb-4">
                        <img 
                          src={testimonial.image} 
                          className="rounded-circle me-3" 
                          alt={testimonial.name}
                          style={{ width: '60px', height: '60px', objectFit: 'cover' }}
                        />
                        <div className="flex-grow-1">
                          <h5 className="mb-1 fw-bold">{testimonial.name}</h5>
                          <p className="mb-2 text-primary fw-medium">
                            <i className="fas fa-medal me-1"></i>
                            {testimonial.profession}
                          </p>
                          <div className="d-flex mb-2">
                            {renderStars(testimonial.rating)}
                          </div>
                        </div>
                        <div className="testimonial-quote-icon">
                          <i className="fas fa-quote-right fa-2x text-primary opacity-25"></i>
                        </div>
                      </div>
                      <p className="card-text mb-0 fs-6 lh-lg">
                        "{testimonial.content}"
                      </p>
                    </div>
                    <div className="card-footer bg-transparent border-0 p-4 pt-0">
                      <div className="d-flex align-items-center justify-content-between">
                        <span className="badge rounded-pill px-3 py-2" style={{
                          background: 'linear-gradient(135deg, #667eea15, #764ba215)',
                          color: '#667eea',
                          border: '1px solid #667eea25'
                        }}>
                          <i className="fas fa-check-circle me-1"></i>
                          Verified Student
                        </span>
                        <small className="text-muted">
                          <i className="fas fa-calendar-alt me-1"></i>
                          Class of 2024
                        </small>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestimonialSection;
